import React, {  Component } from 'react';
import {connect} from 'react-redux';
/* Actions */

class ConfirmDeletePackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }

    handleCancel(event) {
		event.preventDefault();
        this.setState({
            showDialog: false
        });
    }

    handleContinue(event){  
        event.preventDefault();
       this.props.cancelPackage && this.props.cancelPackage(event);
}

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="ConfirmDeletePackage">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <p>Are you sure you want to Delete this package?</p>
                    <div className="noButtonContainer">
                        <a className="noButton blueButton" onClick={this.handleCancel.bind(this)}>CANCEL</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.handleContinue.bind(this)}>YES</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ConfirmDeletePackage = connect(mapStateToProps)(ConfirmDeletePackage);
export default ConfirmDeletePackage;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmDeletePackage.js